export default "__VITE_ASSET__BQiRwIZA__"